<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-3 pb-3 border-bottom">
      <h4 class="mb-0">Lista placówek</h4>
      <d-button
        class="text-nowrap"
        theme="success"
        :disabled="!loaded_customers_shops || load_error"
        @click.prevent="showCustomersInstitutions(customerId)">
        <i class="material-icons">add</i>
        Dodaj placówkę
      </d-button>
    </div>
    <customers-form-institution-prices
      :key="'institution-prices-' + institutions_prices_key"
      :name="'institution-prices-' + institutions_prices_id"
      :close-modal="closeModalPriceInstPrices"
      :shop-id="institutions_prices_id"
      :refresh="handleRefreshAll"
      :show-modal="show_modal_institutions_prices"/>
    <customers-form-institutions
      :key="'customers-form-' + component_institutions_key"
      :close-modal="closeCustomersInstitutions"
      :refresh="refreshShops"
      :show-modal="show_modal_institutions"
      :add-id="add_modal_institutions"
      :edit="edit_modal_institutions"
      :customer-data="customerData"/>
    <d-row
      class="d-flex ml-0 mb-3 page-filters w-100">
      <validation-observer
        ref="customers-filters-form"
        tag="form"
        style="width: 100%;"
        class="d-flex">
        <d-input
          placeholder="Podaj nazwę placówki"
          v-model="filters.search" />
        <d-button
          theme="info"
          outline
          class="text-nowrap ml-2"
          :disabled="!loaded_customers_shops"
          @click.prevent="loadCustomersShops">Szukaj</d-button>

        <d-button
          theme="danger"
          outline
          class="text-nowrap ml-2"
          :disabled="!loaded_customers_shops"
          @click.prevent="clearFilters">Resetuj filtry</d-button>
      </validation-observer>
    </d-row>
    <d-card style="width: 100%; box-shadow: none">
      <table class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
          <tr>
            <th
              scope="col"
              class="border-0 rwd-disabled">Nazwa</th>
            <th
              scope="col"
              class="border-0">Adres</th>
            <th
              scope="col"
              class="border-0">Kontakt</th>
            <th
              scope="col"
              class="border-0 text-nowrap text-center">Indywidualny cennik</th>
            <th
              scope="col"
              class="border-0 text-nowrap text-center">Pojemniki do zwrotu</th>
            <th
              scope="col"
              class="border-0 text-center"
              width="130">Akcje</th>
          </tr>
        </thead>
        <tbody
          v-if="loaded_customers_shops && !load_error && customers_shops"
          :key="'table-' + institutions_key">
          <tr
            v-for="(shops, index) of customers_shops"
            :key="'customers-shops-' + index">
            <td class="align-middle rwd-disabled">
              {{ shops.name }}
            </td>
            <td class="align-middle">
              <div class="rwd-tr-active">
                {{ shops.name }}
              </div>
              <span class="bottom-text">
                Miasto: <span class="bottom-text-value-green">{{shops.city}}</span>
              </span>
              <span class="bottom-text text-nowrap">
                Kod pocztowy: <span class="bottom-text-value">{{ shops.post_code }}</span>
              </span>
              <span class="bottom-text">
                Ulica: <span class="bottom-text-value">{{ shops.address }}</span>
              </span>
            </td>
            <td class="align-middle">
              {{ shops.contact_person ? shops.contact_person : '' }}
              <span class="bottom-text">
                Telefon: <span class="bottom-text-value-green">{{ shops.phone ? shops.phone : '' }}</span>
              </span>
              <span class="bottom-text">
                E-mail: <span class="bottom-text-value-green">{{ shops.email ? shops.email : '' }}</span>
              </span>
            </td>
            <td
              v-if="shops.individual_prices === 1"
              class="align-middle text-center">
              <d-button
                outline
                theme="success"
                @click.prevent="openModalPriceInstPrices(shops.id)"
                class="mr-2"
                title="Edytuj">
                <i class="material-icons mr-1">euro</i>
                Tak
              </d-button>
            </td>
            <td
              v-if="shops.individual_prices !== 1"
              class="align-middle text-center"
              style="opacity: 0.4">
              <d-button
                outline
                :disabled="true"
                theme="dark"
                class="mr-2"
                title="Edytuj">
                <i class="material-icons mr-1">highlight_off</i>
                Nie
              </d-button>
            </td>
            <td
              class="align-middle text-center">
              <d-input-group class="justify-content-center">
                <d-input-group-addon prepend>
                  <d-btn
                    theme="danger"
                    :disabled="isSubmittingContainersForShop === shops.id"
                    @click.prevent="decreaseShopContainersNumber(shops)">
                    <i
                      class="material-icons"
                      style="left: -2px;">remove</i>
                  </d-btn>
                </d-input-group-addon>
                <d-input
                  style="max-width: 65px;"
                  v-model="shops.containers_number"
                  type="number"
                  min="0"
                  :disabled="isSubmittingContainersForShop === shops.id"/>
                <d-input-group-addon append>
                  <d-btn
                    theme="primary"
                    :disabled="isSubmittingContainersForShop === shops.id"
                    @click.prevent="increaseShopContainersNumber(shops)">
                    <i
                      class="material-icons"
                      style="left: -2px;">add</i>
                  </d-btn>
                </d-input-group-addon>
              </d-input-group>

              <d-button
                v-if="shops.containers && shops.containers.length"
                theme="info"
                @click.prevent="showContainersHistory(shops)"
                class="w-100 mx-auto"
                style="max-width: 155px;"
                outline
                size="sm"
                title="Pokaż historię pojemników">
                <i class="material-icons">history</i>
              </d-button>
            </td>
            <td class="align-middle text-center">
              <template v-if="getIsShopContainersChanged(shops)">
                <d-button
                  theme="success"
                  :disabled="isSubmittingContainersForShop === shops.id"
                  @click.prevent="submitShopContainersNumber(shops)"
                  class="mr-2"
                  title="Zapisz ilość pojemników">
                  <i class="material-icons">save</i>
                </d-button>
                <d-button
                  theme="secondary"
                  :disabled="isSubmittingContainersForShop === shops.id"
                  @click.prevent="resetShopContainersNumber(shops)"
                  title="Anuluj zmianę ilości pojemników">
                  <i class="material-icons">clear</i>
                </d-button>
              </template>
              <template v-else>
                <d-button
                  theme="primary"
                  @click.prevent="editCustomersInstitutions(shops.id)"
                  class="mr-2"
                  title="Edytuj">
                  <i class="material-icons">edit</i>
                </d-button>
                <d-button
                  theme="danger"
                  @click.prevent="removeCustomers(shops.id)"
                  title="Usuń">
                  <i class="material-icons">delete</i>
                </d-button>
              </template>
            </td>
          </tr>
          <tr v-if="!customers_shops.length">
            <td
              colspan="6"
              class="text-center">
              Brak placówek do wyświetlenia&hellip;
            </td>
          </tr>
        </tbody>
      </table>

      <d-alert
        v-if="load_error"
        show
        theme="warning">
        Wczytywanie danych nie powiodło się. <a
          href="javascript:window.location.reload();"
        class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
      </d-alert>

      <div
        v-else-if="!loaded_customers_shops"
        class="pb-3 pt-3 text-center">
        Trwa ładowanie danych&hellip;
      </div>
    </d-card>

    <d-modal
      class="crm-new-popup institution-prices"
      v-if="showContainersHistoryModal"
      @close="showContainersHistoryModal = false"
      style="background-color: rgba(0,0,0,0.6)!important;">
      <d-modal-header>
        <d-modal-title>
          <h3 class="page-title">
            Historia pojemników
          </h3>
        </d-modal-title>
      </d-modal-header>
      <d-modal-body>
        <institution-containers-history
          :containers-history="containersHistory" />

        <div class="popup-box-buttons">
          <d-button
            theme="secondary"
            class="text-nowrap"
            @click.prevent="showContainersHistoryModal = false">
            Zamknij
          </d-button>
        </div>
      </d-modal-body>
    </d-modal>
  </div>
</template>

<script>
import FormUtils from './../../../utils/FormUtils.js';
import ListUtils from '@/utils/ListUtils';
import CustomersFormInstitutions from '@/components/forms/customers/CustomersFormInstitution';
import CustomersFormInstitutionPrices from '@/components/forms/customers/CustomersFormInstitutionPrices';
import InstitutionContainersHistory from './InstitutionContainersHistory.vue';

export default {
  name: 'customers-form-shops',
  components: {
    CustomersFormInstitutionPrices,
    CustomersFormInstitutions,
    InstitutionContainersHistory
  },
  props: {
    customerId: {
      type: Number,
      required: true
    },
    customerData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      customers_shops: null,
      filters: {
        search: '',
        products_id: 0
      },
      institutions_key: 0,
      show_modal_institutions: false,
      show_modal_institutions_prices: false,
      institutions_prices_id: '',
      institutions_prices_key: 0,
      component_institutions_key: 0,
      add_modal_institutions: '',
      edit_modal_institutions: '',
      isSubmittingContainersForShop: null,
      loaded_customers_shops: false,
      load_error: false,
      showContainersHistoryModal: false,
      containersHistory: []
    };
  },
  watch: {
    'show_modal_institutions': function () {
      this.component_institutions_key += 1;
    },
    'customers_shops': function (value) {
      if (value) {
        this.institutions_key += 1;
      }
    }
  },
  mounted () {
    this.loadCustomersShops();
  },
  methods: {
    loadCustomersShops () {
      let where = {
        search: this.filters.search,
        customer_id: this.customerId
      };
      FormUtils.loadAdditionalData(this, {
        endpoint: '/customers/shops/items',
        params: {
          pagination: false,
          where
        },
        outputKey: 'customers_shops',
        loadedKey: 'loaded_customers_shops',
        errorKey: 'load_error',
      });
    },
    clearFilters () {
      this.load_error = false;
      this.filters = {
        search: '',
      };
      this.loadCustomersShops();
    },
    refreshShops () {
      this.loadCustomersShops();
    },
    handleRefreshAll () {
      this.loadCustomersShops();
      this.$emit('refresh-all');
    },
    showCustomersInstitutions (id) {
      this.add_modal_institutions = id;
      this.show_modal_institutions = true;
    },
    editCustomersInstitutions (id) {
      this.edit_modal_institutions = id;
      this.show_modal_institutions = true;
    },
    closeCustomersInstitutions () {
      this.show_modal_institutions = false;
      this.add_modal_institutions = '';
      this.edit_modal_institutions = '';
    },
    openModalPriceInstPrices (shopId) {
      this.show_modal_institutions_prices = true;
      this.institutions_prices_id = shopId;
    },
    closeModalPriceInstPrices () {
      this.show_modal_institutions_prices = false;
      this.institutions_prices_id = '';
      this.institutions_prices_key += 1;
    },
    removeCustomers (userID) {
      ListUtils.removeItem(this, {
        endpointBase: '/customers/shops/delete/',
        id: userID,
        successTitle: 'Usunięto placówkę',
        successText: 'Wybrana placówka została usunięta',
        confirmTitle: 'Czy na pewno chcesz usunąć tą placówkę?',
        confirmText: 'Tej operacji nie można cofnąć',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Usuwanie placówki nie powiodło się. Spróbuj ponownie.',
        successAction: () => {
          this.loadCustomersShops();
        },
      });
    },
    decreaseShopContainersNumber (shop) {
      shop.containers_number -= 1;
    },
    increaseShopContainersNumber (shop) {
      shop.containers_number += 1;
    },
    submitShopContainersNumber (shop) {
      this.isSubmittingContainersForShop = shop.id;
      FormUtils.submitInBackground(this, {
        endpoint: '/customers/shops/update-containers-number/' + parseInt(shop.id, 10),
        params: { containers_number: shop.containers_number },
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacja iloci pojemników do zwrotu nie powiodła się. Spróbuj ponownie.',
        successAction: () => {
          this.isSubmittingContainersForShop = null;
          let shopInData = this.customerData.shops.find(item => item.id === shop.id);
          if (!shopInData) {
            return;
          }
          shopInData.containers_number = shop.containers_number;
        },
        failAction: () => {
          this.isSubmittingContainersForShop = null;
        }
      });
    },
    resetShopContainersNumber (shop) {
      if (!shop) {
        return;
      }

      let shopInData = this.customerData.shops.find(item => item.id === shop.id);
      if (!shopInData) {
        return;
      }
      shop.containers_number = shopInData.containers_number;
    },
    getIsShopContainersChanged (shop) {
      if (!shop) {
        return false;
      }
      let shopInData = this.customerData.shops.find(item => item.id === shop.id);
      if (!shopInData) {
        return false;
      }
      return shop.containers_number !== shopInData.containers_number;
    },
    showContainersHistory (selectedShop) {
      this.showContainersHistoryModal = true;
      this.containersHistory = selectedShop.containers;
    }
  }
};
</script>
